"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const Chip_1 = __importStar(require("@mui/material/Chip"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "Chip";
exports.classes = {
    default: `${PREFIX}-default`,
    colorWhite: `${PREFIX}-colorWhite`
};
exports.Root = (0, styles_1.styled)(Chip_1.default)(({ theme }) => ({
    margin: "5px",
    borderRadius: "21px",
    cursor: "pointer",
    fontSize: "16px",
    [`&.${exports.classes.default}`]: {
        color: theme.colours.inter,
        backgroundColor: theme.colours.pearl,
        "&:hover": {
            backgroundColor: theme.colours.alabaster,
            color: theme.colours.focus
        }
    },
    [`&.${exports.classes.colorWhite}`]: {
        backgroundColor: theme.colours.white,
        "&.Mui-disabled": {
            backgroundColor: (0, styles_1.alpha)(theme.colours.white, 0.5)
        }
    },
    "&.Mui-disabled": {
        backgroundColor: (0, styles_1.alpha)(theme.colours.pearl, 0.5),
        color: (0, styles_1.alpha)(theme.colours.inter, 0.3)
    },
    [`&.${Chip_1.chipClasses.colorPrimary}`]: {
        color: theme.colours.white,
        backgroundColor: theme.colours.inter
    },
    [`& .${Chip_1.chipClasses.deleteIcon}`]: {
        width: "16px",
        color: theme.colours.inter
    },
    [`& .${Chip_1.chipClasses.label}`]: {
        paddingLeft: "15px",
        paddingRight: "15px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NoaXAvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkRBQStEO0FBQy9ELGlEQUFxRDtBQUVyRCxNQUFNLE1BQU0sR0FBRyxNQUFNLENBQUM7QUFFVCxRQUFBLE9BQU8sR0FBRztJQUNyQixPQUFPLEVBQUUsR0FBRyxNQUFNLFVBQVU7SUFDNUIsVUFBVSxFQUFFLEdBQUcsTUFBTSxhQUFhO0NBQ25DLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFZLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdkQsTUFBTSxFQUFFLEtBQUs7SUFDYixZQUFZLEVBQUUsTUFBTTtJQUNwQixNQUFNLEVBQUUsU0FBUztJQUNqQixRQUFRLEVBQUUsTUFBTTtJQUNoQixDQUFDLEtBQUssZUFBTyxDQUFDLE9BQU8sRUFBRSxDQUFDLEVBQUU7UUFDeEIsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUMxQixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1FBQ3BDLFNBQVMsRUFBRTtZQUNULGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFNBQVM7WUFDeEMsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUMzQjtLQUNGO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxVQUFVLEVBQUUsQ0FBQyxFQUFFO1FBQzNCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7UUFDcEMsZ0JBQWdCLEVBQUU7WUFDaEIsZUFBZSxFQUFFLElBQUEsY0FBSyxFQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQztTQUNqRDtLQUNGO0lBQ0QsZ0JBQWdCLEVBQUU7UUFDaEIsZUFBZSxFQUFFLElBQUEsY0FBSyxFQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQztRQUNoRCxLQUFLLEVBQUUsSUFBQSxjQUFLLEVBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDO0tBQ3ZDO0lBQ0QsQ0FBQyxLQUFLLGtCQUFXLENBQUMsWUFBWSxFQUFFLENBQUMsRUFBRTtRQUNqQyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1FBQzFCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7S0FDckM7SUFDRCxDQUFDLE1BQU0sa0JBQVcsQ0FBQyxVQUFVLEVBQUUsQ0FBQyxFQUFFO1FBQ2hDLEtBQUssRUFBRSxNQUFNO1FBQ2IsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztLQUMzQjtJQUNELENBQUMsTUFBTSxrQkFBVyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDM0IsV0FBVyxFQUFFLE1BQU07UUFDbkIsWUFBWSxFQUFFLE1BQU07S0FDckI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9